import { LOGO_TYPE_SMINEX, LOGO_TYPE_SMINEX_CLUB, LOGO_TYPE_SMINEX_PERFECTIONISTS } from '@entities/leadCollector';
import { SminexIcon, SminexClubIcon, SminexPerfectionistsIcon } from '@shared/assets/icons';
import { palette } from '@shared/tokens/palette.stylex';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

const SMINEX_CLUB_DEFAULT_WIDTH = '149px';
const SMINEX_CLUB_DEFAULT_HEIGHT = '34px';

interface FormLogoProps {
  type: number;
  color?: string;
  width?: number | string;
  height?: number | string;
}

export const FormLogo = ({ type, color, width, height }: FormLogoProps) => {
  if (type === LOGO_TYPE_SMINEX) {
    return (
      <div {...stylex.props(styles.container)}>
        <SminexIcon color={color ?? palette['greyWhite']} width={width} height={height} />
      </div>
    );
  }

  if (type === LOGO_TYPE_SMINEX_CLUB) {
    return (
      <div {...stylex.props(styles.container)}>
        <SminexClubIcon
          color={color ?? palette['greyWhite']}
          width={width ?? SMINEX_CLUB_DEFAULT_WIDTH}
          height={height ?? SMINEX_CLUB_DEFAULT_HEIGHT}
        />
      </div>
    );
  }

  if (type === LOGO_TYPE_SMINEX_PERFECTIONISTS) {
    return (
      <div {...stylex.props(styles.container)}>
        <SminexPerfectionistsIcon color={color ?? palette['greyWhite']} width={width} height={height} />
      </div>
    );
  }
};
